import { render, staticRenderFns } from "./SocialWall.vue?vue&type=template&id=b43966ba&scoped=true&"
import script from "./SocialWall.vue?vue&type=script&lang=js&"
export * from "./SocialWall.vue?vue&type=script&lang=js&"
import style0 from "./SocialWall.vue?vue&type=style&index=0&id=b43966ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43966ba",
  null
  
)

export default component.exports